export default __webpack_public_path__ + "static/media/logo-us-kohls.be8a50fa.svg";